import {groupRights} from "@services/current-rights.service";
import {guard} from "./guard-factory";

export const guardUsersEdit = guard(groupRights.Users)('edit')
export const guardUsersWatch = guard(groupRights.Users)('watch')
export const guardUsersCreate = guard(groupRights.Users)('create')

